import React from "react"
import { Link } from "gatsby"

const Footer = props => {
  return (
    <footer className="footer">
      <div className="container">
        <p>
          <Link
            to="/"
            title="Ken Walton, front-end developer and graphic designer."
          >
            KWWALTON.com
          </Link>{" "}
          &copy; 2020 by Ken Walton
        </p>
        <ul>
          <li>
            <a href="https://github.com/kwwalton">Github</a>
          </li>
          {/* <li>
            <a href="https://codepen.io/">Code Pen</a>
          </li> */}
          <li>
            <a href="https://www.linkedin.com/in/kenneth-walton-pmp-3915a44b">
              LinkedIn
            </a>
          </li>
        </ul>
      </div>
    </footer>
  )
}

export default Footer
